const EcosiaUser = require('@ecosia/ecosia-user');

const { MAIN } = require('../../constants/cookies');

module.exports = (req) => {
  if (req.user) {
    return req.user;
  }

  const acceptLanguage = req.headers['accept-language'];
  const cookieString = req.cookies.get(MAIN, { parseJSON: false });
  const userAgent = req.headers['user-agent'];
  const user = new EcosiaUser({ cookieString, acceptLanguage, userAgent });

  return user;
};
